// extracted by mini-css-extract-plugin
module.exports = {"root":"our-commitment_root__EXJl4","statsSectionContainer":"our-commitment_statsSectionContainer__EiFAa"};